import invariant from 'tiny-invariant';
import { createContext, useContextSelector } from 'use-context-selector';
const HintContext = createContext(null);
export const HintProvider = HintContext.Provider;
export const useHintContext = () => useContextSelector(HintContext, ctx => {
  invariant(ctx !== null, "Component can't be used outside of <Hint /> component");
  return ctx;
});